import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '#src/context/UserContext';
import { APIGetCompanyData, APIUpdateCompany,} from '#src/api/companies/Companies';
import {ProfileAttribute} from '#src/components/profileAttribute';
import {UserManagement} from "#src/components/userManagement";
//import {XplanStyler} from "#src/components/xplanStyler";
import CompanyTabs from "#src/components/companyTabs.js";
import {AccessManagementCompany} from "#src/components/accessManagementCompany";
import {TokenManagemant} from "#src/components/tokenManagement";
import { WfsProfileManagement } from '#src/components/wfsProfileManagement';
import {GetProductSettingsHandler, verifyPermissions} from "#src/helper/getProductSettingsHandler";
import {Page404} from '#src/pages/Page-404';

export const CompanyPage = () => {
  const { user } = useContext(UserContext);
  const [company, setCompany] = useState(null);
  const [name, setName] = useState('-');
  const [email, setEmail] = useState('-');
  const [phoneNumber, setPhoneNumber] = useState('-');
  const [addressStreet, setAddressStreet] = useState('');
  const [addressZipCode, setAddressZipCode] = useState('');
  const [addressCity, setAddressCity] = useState('');
  const [save, setSave] = useState(false);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const companyData = await APIGetCompanyData(user?.companyId);
              companyData["permissions"] = GetProductSettingsHandler(companyData?.["products"]);

        if (!companyData) {
          throw new Error('Error: Could not load company');
        }
        
        setCompany(companyData);
        setName(companyData.name);
        setEmail(companyData.email);
        setPhoneNumber(companyData.details.phoneNumber);
        setAddressStreet(companyData.details.address.street);
        setAddressZipCode(companyData.details.address.zipCode);
        setAddressCity(companyData.details.address.city);
      } catch (error) {
        console.error('Error:', error);
      }
    };
    
    if (!company) {
      fetchCompanyData();
    }
  }, [company, user]);

  useEffect(() => {
    const saveCompany = async () => {
      try {
        const updatedCompany = {
          ...company,
          name: name,
          details: {
            address: {
              street: addressStreet,
              zipCode: addressZipCode,
              city: addressCity,
              country: ' ',
            },
            phoneNumber: phoneNumber,
          },
        };
        const response = await APIUpdateCompany(updatedCompany, user?.companyId);
        if (response) {
          setSave(false);
        } else {
          throw new Error('Error: Could not save company data');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (save) {
      saveCompany();
    }
  }, [name, email, phoneNumber, addressStreet, addressZipCode, addressCity, save, company, user?.companyId]);

  if (user?.role !== 'admin') {
    return <Page404 />;
  }

  return (
    <div className="mx-auto max-w-7xl bg-gray-100 px-4">
      <h2 className="text-xl my-8 flex ml-4 font-semibold  leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
        Account 
      </h2>
      <CompanyTabs page={"Einstellungen"}/>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-x-8">
        <div>
          <div>
            <div className={"border border-gray-500 rounded-lg divide-y bg-white divide-gray-300 overflow-hidden text-left mb-2 sm:mb-4 md:mb-8"}>
              <div className={'lg:p-6 p-4'}>
                <div className="px-4 sm:px-0 mb-10">
                  <h3 className="font-semibold text-lg text-gray-900">
                    Details
                  </h3>
                </div>
                <div>
                  { company && (
                      <div className={"mt-12"}>
                        <div className="px-4 gap-x-12 sm:px-0">
                          <ProfileAttribute
                              name="Name"
                              value={name}
                              setValue={setName}
                              save={save}
                              setSave={setSave}
                          />
                          <ProfileAttribute
                              name="E-Mail"
                              value={email}
                              setValue={setEmail}
                              save={save}
                              setSave={setSave}
                          />
                          <ProfileAttribute
                              name="Telefonnummer"
                              value={phoneNumber}
                              setValue={setPhoneNumber}
                              save={save}
                              setSave={setSave}
                          />
                          <ProfileAttribute
                              name="Straße"
                              value={addressStreet}
                              setValue={setAddressStreet}
                              save={save}
                              setSave={setSave}
                          />
                          <ProfileAttribute
                              name="Postleitzahl"
                              value={addressZipCode}
                              setValue={setAddressZipCode}
                              save={save}
                              setSave={setSave}
                          />
                          <ProfileAttribute
                              name="Ort"
                              value={addressCity}
                              setValue={setAddressCity}
                              save={save}
                              setSave={setSave}
                          />
                        </div>
                      </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

          <AccessManagementCompany/>
          <TokenManagemant />
          <WfsProfileManagement />
        </div>
      </div>
    </div>
  );
}
